import { render, staticRenderFns } from "./ProfessorSettings.vue?vue&type=template&id=c8fa96a2"
import script from "./ProfessorSettings.vue?vue&type=script&lang=js"
export * from "./ProfessorSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports